import StoriesSlider from './StoriesSlider'

export default StoriesSlider
